export default __webpack_public_path__ + "static/media/store-energy.d77eb283.svg";